(function () {
  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .factory('ParametroService', ParametroService);

  function ParametroService($http, ngsalConfig, PARAMETRO) {

    var service = {
      getLimiteDiasFeitosVistaAberta: getLimiteDiasFeitosVistaAberta
    };

    return service;

    function getLimiteDiasFeitosVistaAberta(anoMes) {

      let endpoint = `/mgp-corregedoria/api/${ngsalConfig.apiVersion}/parametro/`;
      endpoint += `${PARAMETRO.LIMITE_FEITOS_VISTA_ABERTA}?anoMes=${anoMes}`;

      var promise = $http.get(endpoint)
        .then(function (response) {
          return response.data;
      });

      return promise;
    }
  }
})();
